import { FaqAccordionItems } from '@app/widgets';

export const ANDROID_KEYSTORE_GENERATOR_FAQS: FaqAccordionItems[] = [
  {
    question: 'What is a PKCS#12 keystore?',
    answer: [
      'A PKCS#12 (.p12) keystore is a secure file format that stores a private key and its associated certificate.',
      'Android uses this format for signing APKs and App Bundles before publishing to Google Play or other distribution channels.',
      'Learn more about Android keystores in our <a href="https://capawesome.io/cloud/native-builds/certificates/android/" target="_blank">documentation</a>.',
    ].join(' '),
  },
  {
    question: 'Is my data secure?',
    answer: [
      'Yes, absolutely.',
      'The entire keystore generation process runs locally in your browser using the Web Crypto API.',
      'No data — including your private key, password, or personal information — is ever sent to any server.',
    ].join(' '),
  },
  {
    question: 'How do I use the keystore in my CI/CD pipeline?',
    answer: [
      'After generating your keystore, you can upload it to Capawesome Cloud or any other CI/CD platform.',
      'Store the keystore file and its password as secrets in your build environment.',
      'Check our <a href="https://capawesome.io/cloud/native-builds/setup/" target="_blank">setup guide</a> for step-by-step instructions.',
    ].join(' '),
  },
  {
    question: 'Which fields are required?',
    answer: [
      'The required fields are Full Name, Email, Password, Key Alias, and Validity.',
      'Optional fields like Organization, Organizational Unit, City, State, and Country provide additional identity information in your certificate.',
    ].join(' '),
  },
  {
    question: 'How long should the keystore validity be?',
    answer: [
      'Google recommends a validity period of at least 25 years so that your keystore outlasts the lifetime of your app.',
      'The default value of 25 years is a good choice for most apps.',
    ].join(' '),
  },
  {
    question: 'Is the generated keystore compatible with Google Play?',
    answer: [
      'Yes, the generated PKCS#12 keystore is fully compatible with Google Play and other Android distribution channels.',
      'It uses industry-standard RSA 2048-bit keys and SHA-256 signing, which meet all Google Play requirements.',
    ].join(' '),
  },
];
